import { useEffect } from 'react'
import { useAuthStore, useRestaurantStore, useUIStore } from '@restaurant/core'
import { getSupabaseClient } from '@restaurant/core'
import { safeGetLogger } from '@restaurant/logging'
import { isShowcase } from '../showcase/showcase'

const logger = safeGetLogger()

/**
 * Lightweight hook that fetches the user's favorites count on auth.
 * Updates the UI store so QuickButtonsContainer can show/hide the favorites button.
 */
export function useFavoritesCount() {
  const user = useAuthStore((s) => s.user)
  const currentRestaurant = useRestaurantStore((s) => s.currentRestaurant)
  const setFavoritesCount = useUIStore((s) => s.setFavoritesCount)
  const favoritesCountVersion = useUIStore((s) => s.favoritesCountVersion)

  useEffect(() => {
    if (isShowcase()) return
    if (!user?.id || !currentRestaurant?.id) {
      setFavoritesCount(0)
      return
    }

    const fetchCount = async () => {
      try {
        const supabase = getSupabaseClient()
        const { count, error } = await supabase
          .from('user_favorites')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id)
          .eq('restaurant_store_id', currentRestaurant.id)

        if (error) {
          logger?.warn('Failed to fetch favorites count', { error: error.message })
          return
        }

        setFavoritesCount(count ?? 0)
      } catch (err) {
        logger?.warn('Error fetching favorites count', { error: String(err) })
      }
    }

    fetchCount()
  }, [user?.id, currentRestaurant?.id, setFavoritesCount, favoritesCountVersion])
}
